<template>
    <div id="homepage">
        <b-container fluid
            id="container">
            <!-- Navigation -->
            <menu-bar></menu-bar>
            <!-- banner -->
            <banner></banner>
            <!-- about us -->
            <about-us></about-us>
            <!-- products -->
            <products></products>
            <!-- app download -->
            <app-download></app-download>
            <!-- footer -->
            <the-footer></the-footer>
        </b-container>
    </div>
</template>

<script>
import MenuBar from '../components/homepage/NavBar.vue'
import Banner from '../components/homepage/Banner.vue'
import AboutUs from '../components/homepage/AboutUs.vue'
import Products from '../components/homepage/Products.vue'
import AppDownload from '../components/homepage/AppDownload.vue'
import TheFooter from '../components/homepage/TheFooter.vue'

export default {
    name: 'Homepage',
    components: {
        MenuBar,
        Banner,
        AboutUs,
        Products,
        AppDownload,
        TheFooter
    }
}
</script>
